import { dlCartOpenEvent } from './cart/dl.cart.open.event';
import { dlCheckoutStartEvent } from './checkout/dl.checkout.start.event';
import { dlContactEvent } from './dl.contact.event';
import { dlCouponCopiedEvent } from './coupon/dl.coupon.copied.event';
const dataLayerEvents = {
    contact: dlContactEvent,
    couponCopied: dlCouponCopiedEvent,
    openCart: dlCartOpenEvent,
    checkoutStart: dlCheckoutStartEvent
};
document.body.addEventListener('click', (event) => {
    try {
        if (event.target === null || !(event.target instanceof Element))
            return;
        const target = event.target.closest('[data-dl-event]');
        if (target === null || target.dataset.dlEvent === undefined)
            return;
        const [key, value] = target.dataset.dlEvent.split(':');
        dataLayerEvents[key]?.(value);
    }
    catch (e) {
        console.log('dataLayer event error: ', e);
    }
});
